import React, { useEffect, memo } from 'react'
import { Redirect, RouteComponentProps } from 'react-router-dom'

import './styles.css'
import { MainLayout } from '../../components'
import { ToursHeader, ToursPageContent, BottomBar, SortMenuContainer } from './components'
import { ICountry, withAppStoreValue, AppStoreDispatchAction, EAppActionTypes } from '../../store'
import { IAroundMe, INearByTour } from './common'
import { topCategories, toTourCategory } from '../../store/global/tourCategories';

interface IComponentCoreAppStoreProps {
    dispatch: AppStoreDispatchAction
}

const ComponentCore = memo((props: RouteComponentProps & IComponentCoreAppStoreProps) => {
    console.log("Render Tours")

    const { dispatch } = props
    const { country = undefined, aroundMe = undefined, searchText = undefined, nearByTour = undefined, tourId = undefined } = props.location.state || {}

    const actualCountry = country as ICountry
    const actualAroundMe = aroundMe as IAroundMe
    const actualSearchText = searchText as string
    const actualNearByTour = nearByTour as INearByTour

    if (!actualCountry && !actualAroundMe && !actualSearchText && !actualNearByTour && !searchText) return <Redirect to="/" />

    // Do this here to avoid all sorts of issues since it's used in multiple child components
    useEffect(() => {
        const toSelect = actualNearByTour ? actualNearByTour.preSelectedTopCategory : topCategories[0]
        dispatch({ type: EAppActionTypes.SetFilter, filter: toSelect.filter })
        dispatch({ type: EAppActionTypes.SetSelectedTopCategory, selectedTopCategory: toTourCategory(toSelect) })
    }, [])

    return (
        <MainLayout
            hide={!!tourId}
            pageHeader={<ToursHeader />}
            pageContent={(
                <>
                    <ToursPageContent />
                    <SortMenuContainer />
                    <BottomBar />
                </>)}
            scrollBarExtraClassName={'tours-scroll-wrapper'}
        />
    )
})

export default withAppStoreValue<IComponentCoreAppStoreProps, RouteComponentProps>(ComponentCore, ['dispatch'])